import api from './api';

export const getExperts = () => api.get('/admin/experts');
export const createExpert = (data: any) => {
  if (data instanceof FormData) {
    return api.post('/admin/experts', data, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    });
  }
  return api.post('/admin/experts', data);
};
export const updateExpert = (id: number, data: any) => {
  if (data instanceof FormData) {
    data.append('_method', 'PUT');
    return api.post(`/admin/experts/${id}`, data, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    });
  }
  return api.put(`/admin/experts/${id}`, data);
};
export const deleteExpert = (id: number) => api.delete(`/admin/experts/${id}`);

export const downloadResume = (id: number) => {
  return api.get(`/admin/experts/${id}/download-resume`, {
    responseType: 'blob',
  });
};
